import { defineStore } from "pinia";

export const useSetupStore = defineStore("SetupStore" , {
    state: () => {
        return {
            theme: "dark",
        }
    }
})